import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, UrlSerializer } from '@angular/router';
import { ICandidate, IPassport, IScheduleCandidate } from 'src/app/interface/dto';
import { CandidateService } from 'src/app/services/candidate-service.service';
import { firstValueFrom, Subject } from 'rxjs';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { Util } from 'src/app/services/Util';
import { GridUtil } from 'src/app/components/grid/GridUtil';
import { AuthService } from 'src/app/services/http-services/authservice.service';

@Component({
  selector: 'app-view-candidate',
  templateUrl: './view-candidate.component.html',
  styleUrls: ['./view-candidate.component.scss']
})
export class ViewCandidateComponent implements OnInit {

  isReadonly: boolean = true;
  hasPassort = false;
  isNewCandidate: boolean = false;
  candidate: ICandidate = {
    candidateId: 0,
    examNo: '',
    lastName: '',
    firstName: '',
    otherNames: '',
    mobileNo: '',
    emailAddress: '',
    gender: '',
    requiresScreenReader: false,
    extraField1: '',
    extraField2: '',
    extraField3: '',
    skipAIFaceMatching: false,
    unlockPassportPhoto: false,
    testCandidate: false
  }


  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();

  passport: IPassport = {
    examNo: '',
    file: undefined,
    imageUrl: ''
  }
  @ViewChild('passportPix') passportPix;
  mode: any;

  constructor(private candidateService: CandidateService, private snackBar: SnackbarService, private actRoute: ActivatedRoute, private authService: AuthService) { }

  async ngOnInit() {
    const queryParams = await firstValueFrom(this.actRoute.queryParams);
    if (queryParams['examNo']) {
      this.candidate = await this.candidateService.getCandidate(queryParams['examNo']) as ICandidate;
    } else if (this.candidateService.selectedCandidates?.length > 0) {
      this.candidate = await this.candidateService.getCandidate(this.candidateService.selectedCandidates?.[0]?.examNo) as ICandidate;
    }
    this.mode = queryParams['mode'] || '';
    console.log('Mode:', this.mode);

    if (!this.candidate) {
      this.isNewCandidate = true;
      this.isReadonly = false;
      this.candidate = {
        candidateId: 0,
        examNo: '',
        lastName: '',
        firstName: '',
        otherNames: '',
        mobileNo: '',
        emailAddress: '',
        gender: '',
        requiresScreenReader: false,
        unlockPassportPhoto: false,
        skipAIFaceMatching: false,
        testCandidate: false,
        extraField1: '',
        extraField2: '',
        extraField3: ''
      };
      return;
    }
    if (this.mode == 'copy' || this.mode == 'add') {
      this.isNewCandidate = true;
      this.isReadonly = false;
      this.candidate.candidateId = 0; // Reset ID for new candidate
      return;
    }
    if (this.mode == 'edit') {
      this.isReadonly = false;
    }
    this.passport.examNo = this.candidate.examNo;
    await this.candidateService.getCandidatePassport(this.candidate.examNo)
      .then((passport: any) => {
        this.passport = passport;
        if (this.passport.imageUrl) {
          this.passportPix.nativeElement.src = this.passport.imageUrl;
          this.hasPassort = true;
        }
      })
      .catch((error: any) => {
        console.error('Error fetching passport:', error);
      });
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }
  onPassportFileChange(event: any) {
    if (event.target.files && event.target.files[0]) {
      this.passport.file = event.target.files[0];
      this.passportPix.nativeElement.src = URL.createObjectURL(this.passport.file);

    }
  }

  async uploadPassport() {
    if (!this.passport.file) {
      this.snackBar.warning('No file Selected');
      this.hasPassort = true;
      return;
    }

    let formData = new FormData();
    formData.append('examNo', '' + this.candidate.examNo);
    formData.append('file', this.passport.file);
    formData.append('imageUrl', "#");

    this.candidateService.uploadCandidatePassport(formData).then(e => {
      this.snackBar.success('Upload Successfull');
    });
  }

  editForm() {
    this.isReadonly = false;
    this.hasPassort = false;
  }

  async SaveCandidate() {

    this.validateData();
    if (this.isNewCandidate) {
      await this.candidateService.createCandidate(this.candidate).then((candidate) => {
        this.snackBar.success('Candidate Created Successfully');
        GridUtil.setClearGridSelection();
        return window.location.assign("/candidates");
      });
      return;
    }
    await this.candidateService.updateCandidate(this.candidate).then((c: any) => {
      this.snackBar.success('Candidate Updated');
      this.isReadonly = true;
    });
  }

  validateData() {
    if (!this.candidate.firstName) {
      this.snackBar.warning('First Name is required');
      return;
    }

    if (!this.candidate.lastName) {
      this.snackBar.warning('Last Name is required');
      return;
    }
    if (!this.candidate.emailAddress) {
      this.snackBar.warning('Email is required');
      return;
    }
  }

  public getDatestrings(data: Date) {
    return Util.getUserLocalDateTimeString(data , this.authService.user.timezoneOffset);
  }

}
